export const Bio = {
  name: "HIBA EL FARISSI",
  roles: [
    "Web Full Stack Developer",
    "Web Marketer",
    "UI/UX Designer",
  ],
  description:
    "I am a motivated and adaptable professional specializing in web development, marketing, and design. I bring a comprehensive approach to building impactful digital solutions. Driven by a passion for innovation and problem-solving, With a proactive mindset and a dedication to continuous learning .",
  github: "https://github.com/HibaElFarissi",
  resume:
    "https://drive.google.com/file/d/14fScHrnBFvorHyUiN2NlSOKkVHIe3Fis/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/hiba-el-farissi-8161b5279",
  twitter: "https://github.com/HibaElFarissi",
  insta: "https://instagram.com/lea_heba",
  facebook: "https://www.facebook.com/liya.hiba.5",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
     
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://cdn.worldvectorlogo.com/logos/tailwind-css-2.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Laravel",
        image: "https://www.logo.wine/a/logo/Laravel/Laravel-Logo.wine.svg",
      },
      {
        name: "php",
        image:
          "https://clipart-library.com/image_gallery2/PHP-Logo.png",
      },
      
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
     
    ],
  },
  {
    title: "CMS",
    skills: [
      {
        name: "Wordpress",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/98/WordPress_blue_logo.svg",
      },

      {
        name: "WooCommerce",
        image:
          "https://i.postimg.cc/fLk8kF0h/woo-removebg-preview.png",
      },

      {
        name: "Shopify",
        image:
          "https://i.postimg.cc/tJxDNx5S/shopify-removebg-preview.png",
      },
      
      {
        name: "Wix",
        image:
          "https://i.postimg.cc/pVwsXsWg/wix-removebg-preview.png",
      },
      
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://i.postimg.cc/qBzF7t8C/git-removebg-preview.png",
      },
      {
        name: "GitHub",
        image:
          "https://i.postimg.cc/JngH4BMq/github-removebg-preview.png",
      },
      {
        name: "Agile",
        image:
          "https://imgs.search.brave.com/KCLOG64lfFLvFewKUZ-JST98injvGOgrwj3r2ckElOc/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9jZG4u/ZnJlZWJpZXN1cHBs/eS5jb20vbG9nb3Mv/bGFyZ2UvMngvYWdp/bGUtc29mdHdhcmUt/MDEtbG9nby1ibGFj/ay1hbmQtd2hpdGUu/cG5n",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://i.postimg.cc/vBD6svFT/postamn-removebg-preview.png",
      },
      {
        name: "Canva",
        image:
          "https://i.postimg.cc/pXj1DgcW/canva-removebg-preview.png",
      },
      {
        name: "Figma",
        image:
          "https://i.postimg.cc/52qzq0S4/figma-removebg-preview.png",
      },
      {
        name: "UML",
        image:
          "https://i.postimg.cc/sgDcbM1h/wx.png",
      },
    ],
  },
];

export const experiences = [

  {
    id: 4,
    img: "https://i.postimg.cc/8zBpnfYY/2.png",
    role: "Commercial Manager - Desinger",
    company: "LET'S WIN COMMUNITY - MARRAKECH",
    date: "05 April 2024 - 05 August 2024",
    desc: "Handle client calls and schedule appointments effectively. Develop and implement marketing strategies. Manage social media platforms and online advertising (instagram, facebook...) while conducting benchmarking studies.",
    skills: [
      "Canva",
      "Email marketing",
      "Marketing Strategy ",
      "Content Creation & Copywriting",
      "Client Relationship Management",
      "Creativity and communication skills",
    ],
  },
  {
    id: 3,
    img: "https://i.postimg.cc/Jhrrw4Vz/1.png",
    role: "Web Marketer - Desinger",
    company: "CLOUDLINK - MARRAKECH",
    date: "01 April 2024 - 01 May 2024",
    desc: "Create and participate in the development of digital marketing strategies, manage social media accounts, and create engaging content. Design newsletters and promotional posts for advertising campaigns, ensuring brand consistency and audience engagement.",
    skills: [
      "Canva",
      "Email marketing",
      "Strategies Marketing",
      "Content creation",
      "Analytics and reporting",
      "Creativity and communication skills",
    ],
  },

  {
    id: 2,
    img: "https://i.postimg.cc/fRS4mfRQ/Access-Point-Magic-Shop.jpg",
    role: "Full Stack Developer - Desinger",
    company: "ACCESSPOINT - TAROUDANT",
    date: "01 January 2024 - 01 April 2024",
    desc: "Create an E-Commerce site called MagicShop with Laravel PHP technology and Javascript, HTML, CSS, BOOTSTRAP framework in addition Designing some designs for advertisements.",
    skills: [
      "Canva",
      "Laravel",
      "Boostrapp",
      "JavaScript",
      "HTML",
      "CSS",
     
    ],
  },
  
  {
    id: 1,
    img: "https://i.postimg.cc/wMpHV6Vz/aspirants-agency.jpg",
    role: "Full Stack Developer",
    company: "ASPIRANTS AGENCY - FES",
    date: "10 Aout 2023 - 10 October 2023",
    desc: "I Create a blog site called myBlog with  WORDPRESS CMS & I developped also a Blog called Coding Universe With HTML, CSS , TailwindCSS, LaravelPHP",
    skills: [
      "Wordpress",
      "Laravel",
      "TailwindCSS",
      "JavaScript",
      "HTML",
      "CSS",
     
    ],
  },

  {
    id: 0,
    img: "https://i.postimg.cc/d3bsg2vb/FSSM.jpg",
    role: "Full Stack Developer",
    company: "FACULTÉ DES SIENCES FSSM - MARRAKECH ",
    date: "20 March 2023 - 15 Avril 2023",
    desc: "I Create a business management web application With HTML, CSS, BOOTSTRAP, Javascript, Laravel PHP, UML",
    skills: [
      "Laravel",
      "Bootstrap",
      "JavaScript",
      "HTML",
      "CSS",
      "UML",
    ],
  },
  
  
  
  
  
];

export const education = [
  {
    id: 0,
    img: "https://i.postimg.cc/Sxs4V1Wn/ofppt.jpg",
    school: "NTIC ISTA SYBA MARRAKECH",
    date: "2023 - 2024",
    desc: "I completed my education in NTIC ISTA SYBA MARRAKECH , where I studied Technician in Web Marketing, Training focused on essential digital marketing skills, including managing online advertising campaigns, search engine optimization (SEO), social media management....",
    degree: "DIPLÔME TECHNICIEN , Technicien en web marketing",
  },

  {
    id: 1,
    img: "https://i.postimg.cc/Sxs4V1Wn/ofppt.jpg",
    school: "NTIC ISTA SYBA MARRAKECH ",
    date: "2021 - 2023",
    desc: "I completed my education in NTIC ISTA SYBA , where I studied Web developpement, I completed my education at NTIC ISTA SYBA, specializing in web development, where I gained comprehensive knowledge and hands-on experience in designing, coding, and deploying modern web applications. .",
    degree: " DIPLÔME TECHNICIEN SPÉCIALISÉ , Technicien spécialisé en développement digital option web full Stack",
  },

  {
    id: 2,
    img: "https://www.taallim.com/wp-content/uploads/2021/10/IMG-20211024-WA0028-300x241.jpg",
    school: "Lycée Moussa Ibn Noussair",
    date: "2020 - 2021",
    desc: "A diploma focused on physical and chemical sciences, providing a strong foundation in mathematics, physics, and chemistry, along with analytical and methodical skills.",
    degree: "BACCALAURÉAT , SCIENCE PHYSIQUE ET CHIMIE ",
  },

  
];

export const projects = [
  {
    id: 1,
    title: "MagicShop",
    date: " janvier 2024",
    description:
      "MagicShop is an innovative e-commerce platform designed to offer a seamless online shopping experience. Specializing in a wide range of products, MagicShop provides customers with an easy-to-navigate website, secure payment options, and reliable delivery services. Whether shopping for electronics, fashion, or home essentials, MagicShop strives to deliver high-quality products at competitive prices, ensuring customer satisfaction and convenience with every purchase.",
    image:"https://i.postimg.cc/6q6JZsyM/Mgicshop-photo.jpg",
    tags: [
      "Html",
      "Css",
      "JavaScript",
      "Bootstrap",
      "Laravel",
    ],

    category: "Websites",
    github: "https://github.com/HibaElFarissi/MagicShop",
    webapp: "https://magicshop.serv00.net",
  },

  {
    id: 2,
    title: "Human.Resource",
    date: " March 2023",
    description:
      "HumainResource is a web application for business management CRUD",
    image:
      "https://i.postimg.cc/BnM9RrTT/HR.jpg",
    tags: [
      "Html",
      "css",
      "JavaScript",
      "Boostrapp",
      "Laravel PHP",
      "Serv00",
    ],

    category: "Websites",
    github: "https://github.com/HibaElFarissi/HR",
    webapp: "https://humainresource.hibaelfarissi.serv00.net",
  },

  {
    id: 3,
    title: "Foodie",
    date: " February 2024",
    description:
      "Foodie is a user-friendly e-commerce website designed specifically for the food and restaurant industry. It allows customers to easily browse and order a variety of delicious meals from local restaurants, cafes, and food trucks. With a sleek and intuitive interface, Foodie offers a seamless online ordering experience, including options for delivery or pickup. The platform provides features like menu browsing, online payment processing, order tracking, and customer reviews, ensuring convenience and satisfaction. Foodie aims to bring the best local dining experiences to customers' fingertips with a focus on quality, speed, and ease.",
    image:
      "https://i.postimg.cc/mkg1bfcQ/Foodie.jpg",
    tags: [
      "Woordpress",
      "WooCommerce",
      "Canva",
     
    ],
    category: "Wordpress",
    github: "https://foodie.serv00.net",
    webapp: "https://foodie.serv00.net",
  },
  {
    id: 4,
    title: "EnergyGym",
    date: " 13 Mars 2024",
    description:
      "EnergyGym is a comprehensive website and blog dedicated to health, fitness, and wellness. It serves as an online hub for individuals looking to improve their physical well-being through expert advice, workout routines, nutrition tips, and motivational content. The website features a wide range of resources, including workout guides, video tutorials, fitness challenges, and product reviews. Additionally, the blog offers in-depth articles on topics such as mental health, fitness trends, injury prevention, and healthy eating. Whether you're a beginner or an experienced athlete, EnergyGym provides the knowledge and inspiration needed to achieve your fitness goals and lead a healthier lifestyle.",
    image:
      "https://i.postimg.cc/nrkFh0jB/energygym.jpg",
    tags: [
      "Woordpress",
      "WooCommerce",
      "Canva",
      
    ],
    category: "Wordpress",
    github: "https://energygym.serv00.net",
    webapp: "https://energygym.serv00.net",
  },
  
  {
    id: 5,
    title: "OSM Bird",
    date: " April 2023",
    description:
      "Flappy Bird is a popular mobile game that challenges players to navigate a small bird through a series of pipes by tapping the screen to keep it airborne. The game is known for its simple yet addictive gameplay, where players must avoid colliding with the pipes while trying to achieve the highest possible score. The difficulty increases with each passing moment as the bird falls faster, making it harder to avoid the pipes. The game's minimalist design and challenging nature have made it a widely recognized phenomenon, with many players competing to beat their high scores.",
    image:
      "https://i.postimg.cc/ZRRJnTcK/OSM-Bird.png",
    tags: [
      "Html",
      "css",
      "JavaScript",
      "Vercel" ,
      
    ],
    category: "Games",
    github: "https://github.com/HibaElFarissi/OSMBird",
    webapp: "https://osm-bird-hibaelfarissis-projects.vercel.app",
  },

  {
    id: 6,
    title: "Portfolio",
    date: " janvier 2023",
    description:
      "Portfolio is  a web application for Profile offer skill, projects, experiences, education and communication ... ",
    image:
      "https://i.postimg.cc/wxw9Cs9y/protfolio-photo.jpg",
    tags: [
      "Html",
      "css",
    ],

    category: "Websites",
    github: "https://github.com/HibaElFarissi/HTMLProtfolio",
    webapp: "https://elfarissihiba.serv00.net",
  },

  {
    id: 7,
    title: "My Blog",
    date: " Aout 2024",
    description:
      "A WordPress Blog is a website built using WordPress, a popular content management system (CMS) that allows users to easily create and manage blogs and websites.",
    image:
      "https://i.postimg.cc/qBDz8Fh5/myblog.jpg",
    tags: [
      "Canva",
      "Woordpress",
      "WooComerce",
    ],

    category: "Wordpress",
    github: "https://myblog.elfarissihiba.serv00.net",
    webapp: "https://myblog.elfarissihiba.serv00.net",
  },

  {
    id: 8,
    title: "TSM Shop",
    date: " May 2024",
    description:
      "TSM Shop is an eCommerce website designed specifically for selling electronics, providing customers with a seamless online shopping experience. The website allows users to browse, compare, and purchase a wide variety of electronic products, such as smartphones, laptops, cameras, home appliances, and more. ",
    image:
      "https://i.postimg.cc/q7BTDkWX/TSM-Shop.jpg",
    tags: [
      "Canva",
      "Woordpress",
      "WooComerce",
    ],

    category: "Wordpress",
    github: "https://groupcommerce.elfarissihiba.serv00.net",
    webapp: "https://groupcommerce.elfarissihiba.serv00.net",
  },

  {
    id: 9,
    title: "CureCorner",
    date: " August 2024",
    description:
      "CureCorner is an eCommerce website designed to offer a wide range of medical products and healthcare equipment, providing a convenient and secure online shopping experience for patients, healthcare professionals, and caregivers. From medical devices to personal health essentials, CureCorner aims to deliver high-quality healthcare products right to your doorstep  ",
    image:
      "https://i.postimg.cc/dtFSj5bG/curecorner.jpg",
    tags: [
      "Canva",
      "Woordpress",
      "WooComerce",
    ],

    category: "Wordpress",
    github: "https://curecorner.elfarissihiba.serv00.net",
    webapp: "https://curecorner.elfarissihiba.serv00.net",
  },

  {
    id: 10,
    title: "My Protfolio 2",
    date: "October 2024",
    description:
      "Portfolio is a web application for Profile offer skill, projects, experiences, education and communication ...",
    image:
      "https://i.postimg.cc/jSsbjHt4/protfolio-react-app.jpg",
    tags: [
      "React JS",
      "Html",
      "CSS",
      "Bootstrap",
      "Javascript",
      "Vercel",
    ],

  category: "Websites",
  github: "https://github.com/HibaElFarissi/Protfolio-React",
  webapp: "https://protfolio-nu-liart.vercel.app",
  
  },
];


export const TimeLineData = [
  { year: 2021, text: "Started my journey" },
  { year: 2022, text: "Founded JavaScript Mastery and Laravel" },
  { year: 2023, text: "Shared my projects with the world" },
  { year: 2024, text: "Started my own platform" },
];
